<template>
  <v-select item-value="id"
            item-text="locale.en_culture"
            multiple
            hide-details
            dense
            :items="cultures"
            placeholder="Culture"
            v-model="calculation.culture">
    <template v-slot:prepend-item>
      <v-list-item
          ripple
          @mousedown.prevent
          @click="handleSelectAllClick"
      >
        <v-list-item-action>
          <v-icon color="indigo darken-4">
            {{ toggleAllIcon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Select All
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index < 2">
        <span>{{ item.locale.en_culture }}</span>
      </v-chip>
      <span
          v-if="index === 2"
          class="grey--text text-caption"
      >
          (+{{ calculation.culture.length - 2 }} others)
        </span>
    </template>
  </v-select>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "CalcTableCultureSelect",
  props: ['calculation'],
  computed: {
    ...mapState('culture', ['cultures']),
    toggleAllIcon() {
      if (this.calculation?.culture.length === this.cultures?.length) return 'mdi-close-box'
      if (this.calculation?.culture.length > 0) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    ...mapMutations('calculation', ['setNewCalcCultures']),
    handleSelectAllClick() {
      if (this.calculation.culture.length === this.cultures.length) {
        this.calculation.culture = []
      } else {
        this.calculation.culture = this.cultures.map(c => c.id)
      }
    }
  }
}
</script>

<style scoped>

</style>